import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpStatusCode
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';
import { PortalAuthenticationService } from 'src/app/features/portal/_services/portal-authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private sas: AuthenticationService,
    private pas: PortalAuthenticationService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // 401 = not authenticated (expired/invalid token) - force logout.
        // 403 = authenticated but not permitted for this specific resource -
        // must NOT log out. A single request the user's role can't access
        // (e.g. a superadmin-only endpoint called incidentally) previously
        // wiped the whole session and redirected to /login for every role
        // except superadmin, which never happened to hit a 403.
        if (error.status === HttpStatusCode.Unauthorized) {
          if (this.pas.isResponsibleFor(request)) {
            // console.warn('ErrorInterceptor: Portal user unauthorized, logging out');
            this.pas.logout();
          } else if (this.sas.isResponsibleFor(request)) {
            // console.warn('ErrorInterceptor: System user unauthorized, logging out');
            this.sas.logout();
          }
        }

        return throwError(() => error);
      })
    );
  }
}
